export default __webpack_public_path__ + "img/arrow-left.42323897.svg";